var coll = document.getElementsByClassName("collapsible-title");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }

      // Find the closest .footer-categories-items element and toggle the open-link class
      var footerItems = this.closest(".footer-categories-items");
      if (footerItems) {
        footerItems.classList.toggle("open-link");
      }

      // Find the .hidden-footer element and toggle the max-show class
      var hiddenFooter = document.querySelector(".hidden-footer");
      if (hiddenFooter) {
        hiddenFooter.classList.toggle("max-show");
      }
    });
  }